export const Translations_RU = {
	footer: {
		join: "Присоеденись к дискуссии прямо сейчас. Без регистрации. ",
		climate: "Позитивное обсуждение климата",
		tree: "Это дерево посажено.",
		start: "Начни видеодискуссию бесплатно.",
	},
};
